// Mock data for all dashboard features

export const mockClasses = [
  {
    id: 1,
    subject: 'Mathematics',
    grade: 'Grade 10',
    tutor: 'Dr. Priya Sharma',
    student: 'Rahul Kumar',
    schedule: '2025-01-15 10:00 AM',
    meetLink: 'https://meet.google.com/abc-defg-hij',
    status: 'scheduled',
    duration: 60
  },
  {
    id: 2,
    subject: 'Physics',
    grade: 'Grade 11',
    tutor: 'Prof. Rajesh Verma',
    student: 'Ananya Patel',
    schedule: '2025-01-15 02:00 PM',
    meetLink: 'https://meet.google.com/xyz-abcd-efg',
    status: 'scheduled',
    duration: 60
  },
  {
    id: 3,
    subject: 'Chemistry',
    grade: 'Grade 12',
    tutor: 'Dr. Meera Iyer',
    student: 'Arjun Reddy',
    schedule: '2025-01-14 11:00 AM',
    meetLink: 'https://meet.google.com/mno-pqrs-tuv',
    status: 'completed',
    duration: 60
  }
];

export const mockStudents = [
  {
    id: 1,
    name: 'Rahul Kumar',
    email: 'rahul@example.com',
    grade: 'Grade 10',
    subjects: ['Math', 'Science'],
    parent: 'Mrs. Kumar',
    progress: 85,
    sessionsCompleted: 24,
    avatar: 'https://images.unsplash.com/photo-1624486217002-846e654ac969'
  },
  {
    id: 2,
    name: 'Ananya Patel',
    email: 'ananya@example.com',
    grade: 'Grade 11',
    subjects: ['Physics', 'Chemistry'],
    parent: 'Mr. Patel',
    progress: 92,
    sessionsCompleted: 30,
    avatar: 'https://images.unsplash.com/photo-1542810634-71277d95dcbb'
  },
  {
    id: 3,
    name: 'Arjun Reddy',
    email: 'arjun@example.com',
    grade: 'Grade 12',
    subjects: ['Math', 'Physics'],
    parent: 'Mrs. Reddy',
    progress: 78,
    sessionsCompleted: 18,
    avatar: 'https://images.unsplash.com/photo-1565598621680-94ac0c22b148'
  }
];

export const mockTutors = [
  {
    id: 1,
    name: 'Dr. Priya Sharma',
    email: 'priya@fourqlearn.com',
    subjects: ['Mathematics', 'Statistics'],
    rating: 4.9,
    sessionsCompleted: 156,
    earnings: 124800,
    availability: 'Mon-Fri, 9AM-5PM',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2'
  },
  {
    id: 2,
    name: 'Prof. Rajesh Verma',
    email: 'rajesh@fourqlearn.com',
    subjects: ['Physics', 'Chemistry'],
    rating: 4.8,
    sessionsCompleted: 142,
    earnings: 113600,
    availability: 'Mon-Sat, 10AM-6PM',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d'
  },
  {
    id: 3,
    name: 'Dr. Meera Iyer',
    email: 'meera@fourqlearn.com',
    subjects: ['Chemistry', 'Biology'],
    rating: 4.95,
    sessionsCompleted: 178,
    earnings: 142400,
    availability: 'Tue-Sat, 2PM-8PM',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956'
  }
];

export const mockInvoices = [
  {
    id: 'INV-2025-001',
    parent: 'Mrs. Kumar',
    student: 'Rahul Kumar',
    month: 'January 2025',
    sessions: 12,
    amount: 7200,
    discount: 500,
    finalAmount: 6700,
    status: 'paid',
    paidDate: '2025-01-05',
    paymentMethod: 'Razorpay'
  },
  {
    id: 'INV-2025-002',
    parent: 'Mr. Patel',
    student: 'Ananya Patel',
    month: 'January 2025',
    sessions: 15,
    amount: 9000,
    discount: 0,
    finalAmount: 9000,
    status: 'pending',
    dueDate: '2025-01-20'
  },
  {
    id: 'INV-2024-156',
    parent: 'Mrs. Reddy',
    student: 'Arjun Reddy',
    month: 'December 2024',
    sessions: 10,
    amount: 6000,
    discount: 300,
    finalAmount: 5700,
    status: 'paid',
    paidDate: '2024-12-28',
    paymentMethod: 'Razorpay'
  }
];

export const mockMessages = [
  {
    id: 1,
    from: 'Dr. Priya Sharma',
    fromRole: 'tutor',
    to: 'Rahul Kumar',
    toRole: 'student',
    message: 'Hi Rahul! Great work on today\'s quadratic equations. Keep practicing the problems I shared.',
    timestamp: '2025-01-14 03:30 PM',
    read: true
  },
  {
    id: 2,
    from: 'Mrs. Kumar',
    fromRole: 'parent',
    to: 'Dr. Priya Sharma',
    toRole: 'tutor',
    message: 'Thank you for the progress report. Rahul is really enjoying the classes!',
    timestamp: '2025-01-14 05:15 PM',
    read: false
  },
  {
    id: 3,
    from: 'Admin',
    fromRole: 'admin',
    to: 'Dr. Priya Sharma',
    toRole: 'tutor',
    message: 'Your January payment has been processed. Check your earnings dashboard.',
    timestamp: '2025-01-14 09:00 AM',
    read: true
  }
];

export const mockQuizzes = [
  {
    id: 1,
    title: 'Quadratic Equations - Practice Test',
    subject: 'Mathematics',
    grade: 'Grade 10',
    questions: 10,
    duration: 30,
    score: 8,
    totalScore: 10,
    status: 'completed',
    completedDate: '2025-01-13'
  },
  {
    id: 2,
    title: 'Newton\'s Laws of Motion',
    subject: 'Physics',
    grade: 'Grade 11',
    questions: 15,
    duration: 45,
    status: 'pending'
  },
  {
    id: 3,
    title: 'Chemical Bonding Concepts',
    subject: 'Chemistry',
    grade: 'Grade 11',
    questions: 12,
    duration: 40,
    score: 10,
    totalScore: 12,
    status: 'completed',
    completedDate: '2025-01-12'
  }
];

export const mockProgressData = [
  { month: 'Aug', score: 65 },
  { month: 'Sep', score: 72 },
  { month: 'Oct', score: 78 },
  { month: 'Nov', score: 82 },
  { month: 'Dec', score: 85 },
  { month: 'Jan', score: 88 }
];

export const mockBadges = [
  {
    id: 1,
    name: 'Quiz Master',
    description: 'Scored 90% or above in 5 quizzes',
    icon: '🏆',
    earned: true,
    earnedDate: '2024-12-15'
  },
  {
    id: 2,
    name: 'Perfect Attendance',
    description: 'Attended all classes for a month',
    icon: '⭐',
    earned: true,
    earnedDate: '2024-11-30'
  },
  {
    id: 3,
    name: 'Fast Learner',
    description: 'Complete 20 lessons in a month',
    icon: '🚀',
    earned: false
  },
  {
    id: 4,
    name: 'Math Genius',
    description: 'Score 95% in 3 consecutive math tests',
    icon: '🧮',
    earned: false
  }
];

export const mockBillingAnomalies = [
  {
    id: 1,
    type: 'duplicate',
    severity: 'high',
    description: 'Duplicate session detected for Rahul Kumar on 2025-01-10 at 10:00 AM',
    amount: 600,
    status: 'pending',
    detectedDate: '2025-01-14'
  },
  {
    id: 2,
    type: 'pricing_error',
    severity: 'medium',
    description: 'Session charged at ₹700 instead of ₹600 for Ananya Patel',
    amount: 100,
    status: 'resolved',
    detectedDate: '2025-01-12',
    resolvedDate: '2025-01-13'
  }
];